import {Component, inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {CardModule} from 'primeng/card';
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import {TabsModule} from 'primeng/tabs';
import {RegionService} from '@6grain/masofa-monolith-api-client/dictionaries/api/region.service';
import {Region} from '@6grain/masofa-monolith-api-client/dictionaries';
import {RegionManagerService} from '@components/openstreetmap/managers/region-manager.service';
import {ProblemAreasComponent} from '@app/pages/weather/components';
import {DisastersSectionComponent} from '@app/pages/weather/components';
import {DataSourcesComponent} from '@app/pages/weather/components';
import {SummaryWrapper} from '@app/wrappers/summary-wrapper/summary-wrapper';
import {AuthService} from '@services/auth.service';
import {ThemeModule} from '@app/themes/theme-module';
import {IMenuItem} from '@models/i-menu-item';
import {SummaryParent} from '@app/wrappers/summary-parent';
import {MenuChildrenPipe} from '@app/utils/pipes/menu-children.pipe';

@Component({
  selector: 'app-weather-page',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    CardModule,
    TableModule,
    ButtonModule,
    TabsModule,
    ProblemAreasComponent,
    DisastersSectionComponent,
    DataSourcesComponent,
    ThemeModule,
    MenuChildrenPipe
  ],
  templateUrl: './weather-main-menu.component.html',
  styleUrls: ['./weather-main-menu.component.scss'],
})
export class WeatherMainMenuComponent extends SummaryParent implements OnInit {
  protected regionService: RegionService = inject(RegionService);
  protected regionManagementManager: RegionManagerService = inject(RegionManagerService);
  protected translate: TranslateService = inject(TranslateService);

  totalRegions: number = 0;
  totalArea: string = '';
  allRegionsLevel2: Region[] = [];

  items: IMenuItem[] = [];

  private readonly allMenuItems: IMenuItem[] = [
    {
      title: 'GIS',
      icon: '/assets/icons/main/light/icon-gis-fields.svg',
      iconBack: '/assets/icons/main/light/icon-gis-fields-back.svg',
      cardStyle: { background: 'rgba(0, 136, 233, 0.3)' },
      url: '/weather/gis',
    },
    {
      title: 'Tile map',
      icon: '/assets/icons/main/light/icon-field-tile-map.svg',
      iconBack: '/assets/icons/main/light/icon-field-tile-map-back.svg',
      cardStyle: { background: 'rgba(54, 195, 26, 0.6)' },
      url: '/weather/tile-map',
    },
    {
      title: 'Reports',
      icon: 'assets/icons/main/light/icon-repots-front.svg',
      iconBack: 'assets/icons/main/light/icon-repots-back.svg',
      cardStyle: { background: 'rgba(186, 189, 197, 0.8)' },
      url: '/weather/reports',
    },
    {
      title: 'Administration',
      iconBack: '/assets/icons/main/light/ico-admin-line.svg',
      icon: '/assets/icons/main/light/ico-admin-summary.svg',
      cardStyle: { background: 'rgba(186, 189, 197, 0.8)' },
      url: '/weather/administration',
    },
  ];

  currentPage = 1;
  totalPages = 100;

  showModal = false;
  selectedDisaster: any = null;
  modalCurrentPage = 1;

  regions = Array.from({ length: 10 }, (_, i) => i + 1);
  sources = [
    { name: 'DATA_SOURCE_ERA5', date: Date.now().toString() },
    { name: 'DATA_SOURCE_IBM', date: Date.now().toString() },
    { name: 'DATA_SOURCE_UGM', date: Date.now().toString() },
  ];

  constructor(private router: Router) {
    super()
  }

  ngOnInit(): void {
    this.loadAllRegionsLevel_2();
  }

  private loadAllRegionsLevel_2(): void {
    this.regionManagementManager
      .getRegions()
      .then((regions) => {
        if (regions && regions.length > 0) {
          const level2Regions = regions.filter((r) => r.level === 2);
          this.processRegionsLevel2(level2Regions);
        } else {
          this.loadRegionsLevel2FromService();
        }
      })
      .catch(() => {
        this.loadRegionsLevel2FromService();
      });
  }

  private loadRegionsLevel2FromService(): void {
    this.regionService
      .dictionariesRegionGetByQueryPost({
        take: 1000,
        offset: 0,
        filters: [
          {
            filterField: 'level',
            filterValue: 2,
            filterOperator: 0,
          },
        ],
      })
      .subscribe({
        next: (regions) => {
          this.processRegionsLevel2(regions);
        },
        error: () => {},
      });
  }

  private processRegionsLevel2(regions: Region[]): void {
    this.totalRegions = regions.length;
    this.allRegionsLevel2 = regions;
    this.totalArea = regions
      .reduce((sum: number, region: any) => {
        return sum + (region.regionSquare || 0);
      }, 0)
      .toFixed(2);
  }

  openDisasterModal(disaster: { name: string; count: number; area: number; percent: number }) {
    this.selectedDisaster = {
      title: disaster.name,
      date: new Date().toLocaleDateString(),
      time: new Date().toLocaleTimeString(),
      data: [
        {
          region: disaster.name,
          area: disaster.area,
          percentage: disaster.percent.toFixed(2) + '%',
          crops: '—',
        },
      ],
    };
    this.showModal = true;
    this.modalCurrentPage = 1;
  }
}
